import Button from '@material-ui/core/Button';
import { blue } from '@material-ui/core/colors';
import { withStyles } from '@material-ui/core/styles';

const ApplyTalkStyles = withStyles((theme) => ({
    root: {
      display:'flex',
      flex: "1 0 50%",
      fontFamily: "SpoqaHanSansNeo-Regular",
      marginTop: 20,
      fontSize: 20,
      color: theme.palette.getContrastText(blue[900]),
      backgroundColor: blue[800],
      '&:hover': {
        backgroundColor: blue[700],
      },
    },
  }))(Button);

  export default ApplyTalkStyles;